import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

const StyledDiv = styled.div`
  .adjacent-area {
    display: ${p => p.isDragging ? 'none' : 'unset'}
  }
`;

const DndDraggable = ({ data, type, hasDragStyle = true, children }) => {
  // making something draggable
  const [{ isDragging }, drag, preview] = useDrag({
    type,
    item: () => ({ type, data }),
    canDrag: () => data.canMove &&
      (data.isAssignedPlanner || data.isUserAdminForScope) &&
      !data.isPreview &&
      !data.isDeleted,
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  // using function to get style instead of styled-component because of performance issues
  const dragStyle = (dragging) => {
    if (hasDragStyle) {
      return {
        opacity: dragging ? 0.3 : 1,
        height: dragging ? 0 : '',
      };
    }
    return {};
  };

  return (
    <StyledDiv ref={drag} style={dragStyle(isDragging)} isDragging={isDragging}>
      {children}
    </StyledDiv>
  );
};

DndDraggable.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  hasDragStyle: PropTypes.bool,
  children: PropTypes.object.isRequired,
};

export default DndDraggable;
